import React, { useContext, useEffect, useState } from 'react';

// @material-ui/core components

// core components
import GridContainer from '@components/Grid/GridContainer.js';
import GridItem from '@components/Grid/GridItem.js';

import OvsTable from '@components/ReactTable/OvsTable';
import { Column } from 'react-table';

import CardWrapper from '@components/Card/CardWrapper';
import { itemRoutes } from '../constants';
import { SignalContext as Context } from '../context/SignalProvider';
import { tableHeaderGen } from '@components/ReactTable/tableHeaderGen';
import TablePreview from '@components/Loaders/TablePreview';
import { itemTableData } from '../constants/itemTableData';

import ArchiveSignal from './ArchiveSignal';
interface IRTable { }

const ItemPage: React.FC<IRTable> = () => {
  const { items, tableActions, getItems, loading, goTo, paging, setPageLimit } = useContext(
    Context
  );

  const [headers, setHeaders] = useState<Column[]>([]);

  useEffect(() => {
    if (getItems) {
      getItems()
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (items?.length > 0) {
      setHeaders([...itemTableData, ...tableHeaderGen(items[0])]);
    }

  }, [items]);
  if (headers?.length === 0) {
    return <TablePreview items={items || []} loading={loading} />;
  }
  const extendedToolbar = () => {
    return <ArchiveSignal />;
  };
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <CardWrapper>
          <OvsTable
            columns={headers as Column[]}
            data={items || []}
            checkedIds={[]}
            isLoading={loading}
            addItemPageLink={itemRoutes.add}
            tableActions={tableActions}
            goTo={goTo}
            paging={paging}
            extendedToolbar={extendedToolbar}
            setPageLimit={setPageLimit}
          />
        </CardWrapper>
      </GridItem>
    </GridContainer>
  );
};

export default ItemPage;
